import React from 'react';
import classNames from 'classnames';
import styles from './FullSiteSwitchBanner.css';

class FullSiteSwitchBanner extends React.Component {
  render() {
    const { onClickSwitchButton } = this.props;

    return (
      <div className={styles.banner}>
        <div className={styles.modeInfo}>Full Site</div>
        <button
          className={classNames(styles.switchButton, 'switchToMobileSite')}
          onClick={onClickSwitchButton}
        >
          View Mobile Site
        </button>
      </div>
    );
  }
}

FullSiteSwitchBanner.defaultProps = {
  onClickSwitchButton: () => {},
};

export default FullSiteSwitchBanner;
